import axios, { AxiosError, AxiosRequestConfig, AxiosResponse, Method } from "axios";
import { AppConfig, ServerAPIErrorResponse, ServerAPIResponse, UserLoginResponse } from "./interfaces";
import withReactContent, { ReactSweetAlertOptions } from "sweetalert2-react-content";
import Swal, { SweetAlertResult } from "sweetalert2";
import { store } from "../store/store";
import { setLoggedOnUser } from "../store/loggedOnUser";
import { infoColorLight, secondaryColorLight, infoColorDark, secondaryColorDark, pageBackgroundColorDark, pageBackgroundColorLight, primaryTextColorDark, primaryTextColorLight } from "../layouts/theme";
import { setAppConfig } from "../store/appConfig";
import { setCmdbUsers } from "../store/cmdbUsers";
import { setCmdbUsersId } from "../store/cmdbUsersId";
import { setServerAppConfig } from "../store/ServerAppConfig";
import { getAllWells } from "../apiServices/WellsApi";
import { setWells } from "../store/wells";

export async function loadAppConfigFromSettingsFile() {
    const dispatch = store.dispatch;
    await fetch("appsettings.json").then<AppConfig>(r => r.json()).then((data) => {
        const appConfig: AppConfig = {
            SERVER_URL: data.SERVER_URL ?? process.env.REACT_APP_SERVER_URL ?? "",
            ENVIRONMENT: data.ENVIRONMENT ?? process.env.REACT_APP_ENVIRONMENT ?? "",
            APP_VERSION: data.APP_VERSION ?? process.env.REACT_APP_VERSION ?? "",
            APP_LAST_UPDATED: Number(data.APP_LAST_UPDATED ?? process.env.REACT_APP_LAST_UPDATED ?? 0) * 1000,
            DARK_MODE: false
        }
        dispatch(setAppConfig(appConfig));
    })
        .catch(function (error: AxiosError<ServerAPIResponse<any>>) {
            console.log(error);
        });
}

export async function callServerAPI<Type>(method: Method, url: string, data: any = null, responseType: import("axios").ResponseType = 'json'): Promise<AxiosResponse<Type>> {
    return await new Promise(async (resolve, reject) => {
        const appConfig = store.getState().appConfig.value;
        let config: AxiosRequestConfig = {}

        config.method = method; config.url = appConfig.SERVER_URL + url; config.withCredentials = true; config.data = data
        if (responseType) config.responseType = responseType
        await axios.request(config)
            .then(function (response: AxiosResponse<Type>) {
                resolve(response)
            })
            .catch(function (error: AxiosError<ServerAPIErrorResponse<any>>) {
                console.log(error);
                fireAxiosErrorMySwal(error)
                //reject(error.response)
            });
    });
}

export async function callServerGetLoggedonUser(): Promise<AxiosResponse<ServerAPIResponse<UserLoginResponse>>> {
    const dispatch = store.dispatch;
    const appConfig = store.getState().appConfig.value;
    return await new Promise(async (resolve, reject) => {
        var config: AxiosRequestConfig = {}
        config.method = 'GET'; config.data = null; config.url = appConfig.SERVER_URL + '/api/tepng-user/get-loggedon-user'; config.withCredentials = true
        await axios.request(config)
            .then(async function (response: AxiosResponse<ServerAPIResponse<UserLoginResponse>>) {
                dispatch(setCmdbUsers(new Map(response.data.data.cmdb_users.map(u => [u.id, u]))));
                dispatch(setCmdbUsersId(response.data.data.cmdb_users.map(u => u.id)));
                dispatch(setLoggedOnUser(response.data.data.user_logged_on));
                dispatch(setServerAppConfig(response.data.data.server_app_config));
                getAllWells().then(wells => dispatch(setWells(wells)))
                resolve(response)
            })
            .catch(function (error: AxiosError<ServerAPIResponse<any>>) {
                console.log(error);
                reject(error)
            });
    });
}

export function callServerTepngUserLogout() {
    const dispatch = store.dispatch;
    const appConfig = store.getState().appConfig.value;
    dispatch(setLoggedOnUser(null));
    let url = new URL(window.location.origin)
    // needed to logout of microsoft - the frond end url needs to be added to Azure App registration Redirect URIs to allow for logout redirect
    window.location.replace(appConfig.SERVER_URL + '/.auth/logout?post_logout_redirect_uri=' + window.encodeURIComponent(url.href));
}


export async function fireAxiosErrorMySwal(error: AxiosError<ServerAPIErrorResponse<any>>) {
    if (error?.response?.data instanceof Blob && error?.response?.data?.type && error?.response?.data?.type.toLowerCase().indexOf('json') !== -1) {
        var errorString = JSON.parse(await error.response.data.text());
        showAlertError(errorString.message)
    }
    else {
        if (error?.response == null)
            showAlertError(error.message)
        else if (error?.response?.data?.detail == null)
            showAlertError(error.response.status + ' ' + error.response.statusText)
        else
            showAlertError(error?.response?.data?.detail)
    }
}

export function showAlertError(message: string) {
    const MySwal = withReactContent(Swal);
    MySwal.fire(alertError(message))
}

function alertError(message: string): ReactSweetAlertOptions {
    const appConfig = store.getState().appConfig.value;
    return {
        icon: 'warning',
        title: '',
        html: message,
        showDenyButton: true,
        denyButtonText: 'OK',
        showConfirmButton: false,
        background: appConfig.DARK_MODE ? pageBackgroundColorDark : pageBackgroundColorLight,
        color: appConfig.DARK_MODE ? primaryTextColorDark : primaryTextColorLight,
    }
}
export function showBackDrop(message: string): ReactSweetAlertOptions {
    const appConfig = store.getState().appConfig.value;
    return {
        title: message,
        background: appConfig.DARK_MODE ? pageBackgroundColorDark : pageBackgroundColorLight,
        color: appConfig.DARK_MODE ? primaryTextColorDark : primaryTextColorLight,
        html: '<div style="height:150px;width:150px;margin: 0 auto;"><img style="width: 100px;" src="../../assets/images/loading-icon-red.gif" /><br> <strong> Please Wait... </strong> </div>', showConfirmButton: false, showCancelButton: false, allowOutsideClick: false,
    }
}

export function showConfirmBox(message: string, title: string = 'Confirm', yesButtonText: string = 'Yes', noButtonText: string = 'No'): Promise<SweetAlertResult<any>> {
    const MySwal = withReactContent(Swal);
    const appConfig = store.getState().appConfig.value;
    return MySwal.fire({
        title: `<span style="font-size:16px">${title}</span>`,
        html: message,
        icon: 'question',
        cancelButtonColor: appConfig.DARK_MODE ? infoColorDark : infoColorLight,
        cancelButtonText: noButtonText,
        showCancelButton: true,
        confirmButtonColor: appConfig.DARK_MODE ? secondaryColorDark : secondaryColorLight,
        confirmButtonText: yesButtonText,
        background: appConfig.DARK_MODE ? pageBackgroundColorDark : pageBackgroundColorLight,
        color: appConfig.DARK_MODE ? primaryTextColorDark : primaryTextColorLight,
        iconColor: appConfig.DARK_MODE ? primaryTextColorDark : primaryTextColorLight,
    })
}

/**
 * Returns the fullname of a user
 */
export function getUserFullName(userId: string | null | undefined, includeIGG: boolean = true) {
    if (userId == null) return ''
    const cmdbUsers = store.getState().cmdbUsers.value;
    var user = cmdbUsers.get(userId)
    return user == null ? userId : user.full_name + (includeIGG ? " (" + user.igg + ")" : '')
}

/**
 * Returns the email of a user
 */
export function getUserEmail(userId: string | null | undefined) {
    if (userId == null) return ''
    const cmdbUsers = store.getState().cmdbUsers.value;
    var user = cmdbUsers.get(userId)
    return user == null ? userId : user.email
}


export function xx_getNameFromTotalEnergiesEmail(email: string) {
    if (Boolean(email) === false) return ''
    let names = email.toLowerCase().replace("@external.totalenergies.com", '').replace("@totalenergies.com", '').split('.')
    names = names.map(txt => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase())
    return names.join(' ')
}


export function formatDate(date: Date, format: string) {
    let d = new Date(date);

    if (format === 'time') {
        return d.toLocaleTimeString('en-US');
    }
    else if (format === 'date') {
        let y = d.getFullYear();
        let m = d.getMonth();
        let dd = d.getDate();
        let months_of_year = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

        return `${months_of_year[m] + ' ' + dd + ', ' + y}`
        //   return d.toDateString();
    }
    else {
        return d.toDateString() + ' ' + d.toLocaleTimeString('en-US');
    }
}

export function formatDateTimeLocal(date: Date | null | undefined) {
    if (date == null) return ""
    date = new Date(date);
    const day = `${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
    const month = `${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}`;
    const year = (date.getFullYear() + '').padStart(4, '0')
    const hour = (date.getHours() + '').padStart(2, '0')
    const min = (date.getMinutes() + '').padStart(2, '0')
    return `${year}-${month}-${day}T${hour}:${min}`;
}
export function formatDateTimeLocalNearestHour(date: Date | null | undefined) {
    if (date == null) return new Date()
    date = new Date(date);
    date.setHours(date.getHours() + 1);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
}
export function formatShortDateString(dtStr: Date, includeTime = false): string {
    var dateOptions: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: '2-digit' };
    var timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
    var dt = new Date(dtStr)
    return dt.toLocaleDateString('en-GB', dateOptions) + (includeTime ? " " + dt.toLocaleTimeString('en-GB', timeOptions) : '')
}